import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtUser } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    UserFilters,

    SortUsers,
    AddProjectUser,
    GetMaxProjectUsers,

    closeModal,
    setNotAssignedProjectUserIds,
    setNotAssignedProjectUserSort,
    setNotAssignedProjectUserFilters,
    setNotAssignedProjectUserSelected,
    setProjectUserReloadList,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import UserSearch from "client/pages/search/userSearch"
import Columns from "./columns"

let isMounted: boolean

const NotAssignedUsers = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)

    const accountUserList = useSelector((state: StoreType) => state.accountUser.accountUserList)
    const projectUserList = useSelector((state: StoreType) => state.projectUser.projectUserList)

    const userIds = useSelector((state: StoreType) => state.projectUser.notAssignedUsers.userIds)
    const sortColumn = useSelector((state: StoreType) => state.projectUser.notAssignedUsers.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.projectUser.notAssignedUsers.sortOrder)
    const filters = useSelector((state: StoreType) => state.projectUser.notAssignedUsers.filters)
    const selected = useSelector((state: StoreType) => state.projectUser.notAssignedUsers.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedUserIds = SortUsers(Object.values(userList), sortColumn, sortOrder, filters)
        const accountUserIds = (accountUserList && accountUserList[project.accountId]) || []
        const projectUserIds = (projectUserList && projectUserList[project.id]) || []

        const sortedNotAssigned = sortedUserIds.filter((userId) => (
            accountUserIds.includes(userId) && !projectUserIds.includes(userId)
        ))
        dispatch(setNotAssignedProjectUserIds(sortedNotAssigned))
    }, [accountUserList, projectUserList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtUser, order) => {
        dispatch(setNotAssignedProjectUserSort(column, order))
    }

    const onFilter = (newFilters: UserFilters) => {
        dispatch(setNotAssignedProjectUserFilters(newFilters))
        dispatch(setNotAssignedProjectUserSelected(null))
    }

    const addProjectUsers = () => {
        setSaveState(PENDING)
        const { maxTeamMembers } = GetMaxProjectUsers(packageSettings)
        AddProjectUser(selected, project.id, maxTeamMembers).then(() => {
            if (isMounted) {
                setSaveState(IDLE)
                dispatch(closeModal())
            }
            dispatch(setNotAssignedProjectUserSelected(null))

            dispatch(setProjectUserReloadList(false))
            setTimeout(() => {
                dispatch(setProjectUserReloadList(true))
            }, 0)
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectUser_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <UserSearch
                        id="notAssignedProjectUsers"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={userList}
                    dataIds={userIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button variant="success" onClick={addProjectUsers}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotAssignedUsers
